module.exports = __webpack_public_path__ + "img/icon_zepto.4910a819.png";